import { useCallback } from 'react';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import { getCdnUrl } from '@/helpers';
import PortalProps from '@/interfaces/portals';
import { StyledProp } from '@/styled';

export const PORTALS_CARD_IMAGE_HEIGHT = 200;

interface PortalCardProps extends StyledProp, PortalProps {}

const PortalCard = ({ title, image, old_image, domain, subdomain, thumbnail, id }: PortalCardProps) => {
  const currentImage = getCdnUrl(thumbnail, image, old_image);
  const currentUrl = domain ?? subdomain;

  const handleClick = useCallback(() => {
    window.open(currentUrl, '_blank');
  }, [currentUrl]);

  return (
    <BaseCard image={{ src: currentImage, aspect: '1:1' }} onClick={handleClick} id={`portal-card-${id}`}>
      <Typography.Text strong ellipsis>
        {title}
      </Typography.Text>
    </BaseCard>
  );
};

export default PortalCard;
